// extracted by mini-css-extract-plugin
export default {"create-modal-form":"DowngradeDomainModal_create-modal-form__OoGYO","rules":"DowngradeDomainModal_rules__dqunO","submit-buttons":"DowngradeDomainModal_submit-buttons__SeLNI"};